<template>
  <div class="companyText">
    <video-player
      class="video-player vjs-custom-skin video-warp"
      style="object-fit: fill"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      v-if="videoshow"
    />
    <vue-seamless-scroll
      :data="imgList"
      :class-option="Option"
      class="seamless-warp2"
      v-else
    >
      <ul class="item">
        <li v-for="(item, index) in imgList" :key="index">
          <img :src="item" class="companyImg" />
        </li>
      </ul>
    </vue-seamless-scroll>
    <p class="companyP">
      {{ introduction }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["introduction", "videoshow", "imgList", "propaganda"],
  data() {
    return {
      // 企业视频
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        // aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", // url地址
          },
        ],
        // poster:
        //   "https://p1.music.126.net/5zs7IvmLv7KahY3BFzUmrg==/109951163635241613.jpg?param=600y500", // 你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  computed: {
    // 画册轮播配置
    Option() {
      return {
        step: 4, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 2000, 
      };
    },
  },
  mounted() {
     this.playerOptions.sources[0].src = this.propaganda[0];
  },
  watch: {
    propaganda() {
      if (this.propaganda == undefined || this.propaganda.length <= 0) {
        console.log("22222");

      } else {
        console.log("3333");
        this.playerOptions.sources[0].src = this.propaganda[0];
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 示范企业
.companyText {
  margin-top: 22px;
  word-break: break-all;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

.companyText img {
  border-radius: 3px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 0 8px;
  background: #fbfbfb;
  border: 1px solid #ddd;
  margin: 10px auto;
  margin-left: 15px;
  padding: 5px;
}

.companyImg {
  width: 300px;
  height: 260px;
}
.companyP {
  min-height: 300px;
  font-size: 16px;
  font-family: AdobeHeitiStd-Regular;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  text-indent: 32px;
text-align: justify;
}

// 轮播图片
.seamless-warp2 {
  overflow: hidden;
  height: 280px;
  width: 340px;
  margin-right: 30px;
  float: left;
}
// 视频
.video-warp {
  width: 340px;
  margin-right: 30px;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/digital_industry/companyInformation/menu1.vue